// Custom components
import React from "react";

function Select(props) {
  const { children, height, placeholder, state, ...others } = props;

  let className = "w-full outline-none text-sm border";
  if (state === "error") {
    className +=
      " border-red-500 dark:border-red-400 dark:text-red-400 invalid:!text-red-400";
  } else {
    className +=
      " border-gray-200 dark:border-gray-700 dark:text-white invalid:!text-gray-500";
  }

  if (height === "auto") {
    className += " py-2 rounded-lg md:rounded-xl";
  } else {
    className += " h-10 rounded-3xl md:rounded-2xl";
  }

  return (
    <select className={className} {...others}>
      {placeholder && (
        <option value="" disabled hidden>
          {placeholder}
        </option>
      )}
      {children}
    </select>
  );
}

export default Select;
